import {toast} from 'react-toastify';

export const copyToClipboard = (
  value: string,
  label: string = 'Content has been Copied',
) => {
  navigator.clipboard
    .writeText(value)
    .then(() => {
      toast.info(`${label}`, {position: 'top-right'});
    })
    .catch(() => {
      toast.error('Failed to copy', {position: 'top-right'});
    });
};
